import { useState, useEffect } from 'react';

// Tipo para el valor del rol (puedes extenderlo si hay más roles)
type Role = 'visor' | null;

// Hook personalizado
export const useRole = () => {
  const [isVisor, setIsVisor] = useState<boolean>(false);

  useEffect(() => {
    // Obtener el valor de "role" desde localStorage
    const role: Role = localStorage.getItem('role') as Role;

    // Actualizar el estado si el rol es "visor"
    setIsVisor(role === 'visor');
  }, []); // El efecto solo se ejecuta al montar el componente

  return { isVisor };
};
